import { Component, OnInit, Input } from '@angular/core';
import { Device } from '../../../devices.model_new';
import { DevicesService } from '../../../devices.service';
import { ClimatizationDeviceTypesMap, ClimatizationDeviceType } from '../../../devices.constant';

@Component({
  selector: 'app-temperature-detail',
  templateUrl: './temperature-detail.component.html',
  styleUrls: ['./temperature-detail.component.scss']
})
export class TemperatureDetailComponent implements OnInit {
@Input()
device: Device;
ClimatizationDeviceTypesMap = ClimatizationDeviceTypesMap;
ClimatizationDeviceType = ClimatizationDeviceType;

  constructor(private devicesService: DevicesService) { }

  ngOnInit() {
  }

  getProperties(type: string) {
    return ClimatizationDeviceTypesMap.map.get(ClimatizationDeviceType.TEMPERATURE).properties[type];
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/climatization-detail/temperature-detail/temperature-detail.component.ts